import React from 'react';
import '../../Default.css';


function Drive() {
    return (
        <>
            <div className="page-title">
                Prejazd autokarów
            </div>
            <div className='boxes-contener'>
                <div className="copyright-tekst">paczka informacyjna ZHR</div>

                <div className="text-box-header">CZAS I MIEJSCE ZBIÓRKI</div>
                <div className="text-box">
                    <div className="list-header">Na wyjazd 23.07</div>
                    <ul>
                        <li>Gdańsk – ul. Zator Przytockiego 4, godz. 9:00 </li>
                        <li>Warszawa – Plac Defilad, godz. 9:00 </li>
                        <li>Poznań (druhny ze Śląska) – godz. 13.00 </li>
                        <li>Biała Podlaska (druhny z Okręgu Lubelskiego) godz. 7.00 </li>
                    </ul>
                </div><div className="text-box">
                    <div className="list-header">Na wyjazd 29.07</div>
                    <ul>
                        <li>Kraków – miejsce zostanie podane w osobnym mailu, jak otrzymamy potwierdzenie z biura RPD</li>
                    </ul>
                </div>
                <div className="text-box-header">TRASA PRZEJAZDU</div>
                <div className='text-box'>
                    <div className="list-header">Grupa wyruszająca 23.07.</div>
                    <p>Wyjazd</p>
                    <ul>
                        <li>23 VII Warszawa (Gdańsk) - Heilbronn nocleg i śniadanie </li>
                        <li>24 VII Heilbron - 25 VII 9.00 Barcelona i zwiedzanie </li>
                        <li>25 VII 18.00 Barcelona - 26 VII Faro 13.00 </li>
                    </ul>
                    <p>Powrót</p>
                    <ul>
                        <li>6 VIII 17.00 Lizbona - Salamanca + nocleg</li>
                        <li>7 VIII Salamanca - 8 VIII 6.00 Paryż + 9 h w Paryżu</li>
                        <li>9 VIII 15.00 Paryż - 9 VIII 7.00 Słubice/Kołbaskowo</li>
                        <li>9 VIII 7.00 Słubice/Kołbaskowo - 13.00 Warszawa/Gdańsk</li>
                    </ul>
                    <div className='text-box-small-accent'>
                        Osoby odpowiedzialne za poszczególne autokary
                        <ul>
                            <li>Gdańsk: pwd. Tomasz Zelma HR (739-905-539)</li>
                            <li>Warszawa: hm. Robert Kawałko HR (605-259-388); phm. Piotr Słowakiewicz HR</li>
                        </ul>
                    </div>
                </div><div className="text-box">
                    <div className="list-header">Grupa wyruszająca 29.07.</div>
                    <p>Wyjazd</p>
                    <ul>
                        <li>29 VII Kraków – Heidelberg (kolacja + nocleg)</li>
                        <li>30 VII Heidelberg (śniadanie) – Lourdes (kolacja + nocleg)</li>
                        <li>31 VIII Lourdes (śniadanie + czas na zwiedzanie do 11:00) – wyjazd w kierunku Lizbony (kolacja na trasie)</li>
                        <li>01 VIII – godz: 03:00 przyjazd do Lizbony</li>
                    </ul>
                    <p>Powrót</p>
                    <ul>
                        <li>7 VIII Lizbona – Madryt (czas na zwiedzanie, kolacja + nocleg)</li>
                        <li>08 VIII Madryt – Celrmond Ferrand/Dijon (kolacja na trasie, nocleg)</li>
                        <li>09 VIII Clermoncd Ferrand/Dijon – wyjazd w kierunku Krakowa (nocleg w autokarze)</li>
                        <li>10 VIII – godz: 11.00 przyjazd do Krakowa</li>
                    </ul>
                    <div className='text-box-small-accent'>
                        Osoby odpowiedzialne za poszczególne autokary
                        <ul>
                            <li>pwd. Gabriela Cyran HO (519-394-321)</li>
                            <li>pwd. Teresa Holerek HO (883-604-312)</li>
                        </ul>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Drive;
